import { render, staticRenderFns } from "./ClaimDataItem.vue?vue&type=template&id=6e2b5fc7&"
import script from "./ClaimDataItem.vue?vue&type=script&lang=js&"
export * from "./ClaimDataItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports